import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 45,
    seconds: 30
  });
  const totalSpots = 200;
  // Inicia entre 60% y 80% lleno => 40 a 80 cupos restantes.
  const [spots, setSpots] = useState(() => {
    const minRemaining = Math.round(totalSpots * 0.2); // 80% lleno
    const maxRemaining = Math.round(totalSpots * 0.4); // 60% lleno
    return Math.floor(Math.random() * (maxRemaining - minRemaining + 1)) + minRemaining;
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    // Disminuye lento pero nunca baja del 60% lleno (80 cupos restantes).
    const spotsTimer = setInterval(() => {
      setSpots(prev => prev > Math.round(totalSpots * 0.2) ? prev - 1 : prev);
    }, 45000);
    return () => {
      clearInterval(timer);
      clearInterval(spotsTimer);
    };
  }, []);
  // Barra muestra el porcentaje LLENO (siempre entre 60% y 80%).
  const percentage = (totalSpots - spots) / totalSpots * 100;
  return <div className="bg-black border border-zinc-800 rounded-xl p-4 mb-6 text-center" data-id="element-124">
      <h3 className="text-sm font-bold mb-3 text-white uppercase tracking-wider" data-id="element-125">
        🔥 Oferta por tiempo limitado
      </h3>

      <div className="flex justify-center items-center gap-2 mb-4" data-id="element-126">
        {[{
        v: timeLeft.hours,
        l: 'Hs'
      }, {
        v: timeLeft.minutes,
        l: 'Min'
      }, {
        v: timeLeft.seconds,
        l: 'Seg'
      }].map((unit, i) => <Fragment key={unit.l} data-id="element-127">
            {i > 0 && <span className="text-xl font-bold text-zinc-600 -mt-3" data-id="element-128">:</span>}
            <div className="flex flex-col items-center" data-id="element-129">
              <div className="bg-zinc-900 text-[var(--pd-green)] font-display text-3xl w-14 h-14 flex items-center justify-center rounded-lg border border-zinc-800" data-id="element-130">
                {String(unit.v).padStart(2, '0')}
              </div>
              <span className="text-[10px] text-zinc-500 mt-1 uppercase font-bold" data-id="element-131">
                {unit.l}
              </span>
            </div>
          </Fragment>)}
      </div>

      <div className="mb-1.5 flex justify-between text-xs font-bold" data-id="element-132">
        <span className="text-zinc-300" data-id="element-133">Cupos disponibles</span>
        <span className="text-[var(--pd-red)] animate-pulse" data-id="element-134">
          {spots} / 200
        </span>
      </div>
      <div className="w-full bg-zinc-800 rounded-full h-2.5 overflow-hidden" data-id="element-135">
        <motion.div className="bg-[var(--pd-red)] h-2.5 rounded-full" initial={{
        width: 0
      }} animate={{
        width: `${percentage}%`
      }} transition={{
        duration: 1
      }} data-id="element-136" />
      </div>
    </div>;
}